import { Link } from "react-router-dom";
import { Github, Twitter, Instagram, Youtube, Mail } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";

const Col = ({ title, links }) => (
  <div>
    <h4 className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">{title}</h4>
    <ul className="space-y-2.5">
      {links.map((l) => (
        <li key={l.label}>
          <Link to={l.to} className="text-sm text-foreground/70 transition-colors hover:text-primary">{l.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer className="border-t border-border bg-secondary/30" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
      <div className="grid grid-cols-2 gap-10 md:grid-cols-5">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <BrandMark className="h-9" />
            <span className="font-heading text-lg font-bold tracking-tight">Z2Infinity</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-muted-foreground">
            AI-powered JEE &amp; NEET preparation. Unlimited expert-verified practice questions
            grounded in real previous-year papers.
          </p>
          <div className="mt-5 flex gap-3">
            {[Twitter, Instagram, Youtube, Github].map((Icon, i) => (
              <a key={i} href="#" aria-label="social" className="flex h-9 w-9 items-center justify-center rounded-full border border-border text-muted-foreground transition-colors hover:border-primary hover:text-primary">
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
        <Col title="Product" links={[
          { label: "Practice PYQ", to: "/practice" },
          { label: "Chapter Practice", to: "/chapters" },
          { label: "My Progress", to: "/stats" },
          { label: "Pricing", to: "/" },
        ]} />
        <Col title="Company" links={[
          { label: "About us", to: "/" },
          { label: "How it works", to: "/" },
          { label: "Contact", to: "/" },
          { label: "Blog", to: "/" },
        ]} />
        <Col title="Get started" links={[
          { label: "Create account", to: "/register" },
          { label: "Sign in", to: "/login" },
          { label: "Privacy policy", to: "/privacy-policy" },
          { label: "Terms of service", to: "/" },
        ]} />
      </div>
      <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-border pt-6 sm:flex-row">
        <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Z2Infinity. All rights reserved.</p>
        <a href="mailto:hello@jeemaster.com" className="flex items-center gap-1.5 text-xs text-muted-foreground transition-colors hover:text-primary">
          <Mail className="h-3.5 w-3.5" /> hello@jeemaster.com
        </a>
      </div>
    </div>
  </footer>
);
